import { Link } from 'react-router-dom';
import { useProfile } from '../api/hooks';
import { Loader, ErrorView } from '../components/StateViews';
import { Avatar } from '../components/Avatar';
import { MascotWatermark } from '../components/Watermark';
import { GearIcon } from '../components/icons';
import { shortDate, seasonLabel } from '../format';

export function ProfileScreen() {
  const { data, isLoading, isError, error } = useProfile(null);

  if (isLoading) return <Loader />;
  if (isError || !data) return <ErrorView message={(error as Error)?.message} />;

  const { rank, points, wins, gamesPlayed, itmPercent } = data.stats;

  return (
    <div>
      <header className="bhead" style={{ paddingBottom: 18 }}>
        <MascotWatermark pos="bl" />
        <div className="bhead-top">
          <div className="bhead-title bhead-title--sm">Профиль</div>
          <Link to="/settings" className="hbtn" aria-label="Настройки">
            <GearIcon />
          </Link>
        </div>
        <div className="profile-head">
          <Link to="/settings/edit" className="profile-avatar-wrap" aria-label="Изменить фото и имя">
            <Avatar name={data.displayName} src={data.photoUrl} size={86} />
            {rank ? <div className="rank-badge">#{rank}</div> : null}
          </Link>
          <div className="profile-name">{data.displayName}</div>
          <div className="profile-sub">
            <b>{points}</b> очков{data.seasonId ? ` · ${seasonLabel(data.seasonId)}` : ''}
          </div>
        </div>
      </header>

      <div className="content">
        <div className="stats-grid">
          <Link className="stat-tile stat-tile--profile" to="/me/tournaments?filter=wins">
            <div className="val">{wins}×</div>
            <div className="lbl">Победы</div>
          </Link>
          <Link className="stat-tile stat-tile--profile" to="/me/tournaments?filter=inmoney">
            <div className="val">{itmPercent}%</div>
            <div className="lbl">В очках</div>
          </Link>
          <Link className="stat-tile stat-tile--profile" to="/me/tournaments">
            <div className="val">{gamesPlayed}</div>
            <div className="lbl">Турниров</div>
          </Link>
        </div>

        <div className="section-header">
          <h2>Последние 10 турниров</h2>
          <Link to="/me/tournaments" className="section-link">
            Все →
          </Link>
        </div>
        {data.recent.length === 0 ? (
          <div className="muted tiny">Пока нет сыгранных турниров</div>
        ) : (
          <div>
            <div className="lb-head">
              <span>Место · Турнир</span>
              <span>Очки</span>
            </div>
            {data.recent.map((r) => {
              const top = r.position !== null && r.position <= 3;
              return (
                <Link className="recent-row" key={r.gameId} to={`/tournaments/${r.gameId}/results`}>
                  <div className={`pos-badge ${top ? 'pos-badge--top' : 'pos-badge--low'}`}>
                    {r.position ?? '—'}
                  </div>
                  <div className="info">
                    <div className="t">{r.title ?? r.format ?? 'Турнир'}</div>
                    <div className="d">{shortDate(r.startTime)}</div>
                  </div>
                  {r.points > 0 ? (
                    <div className="pts">+{r.points}</div>
                  ) : (
                    <div className="pts pts--none">без очков</div>
                  )}
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
